module.exports = __webpack_public_path__ + "img/qrcode.1ad678bc.png";